var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('router-link',{attrs:{"to":{ name: 'AGB'}}},[_vm._v("Manuel Rau 2022 Copyright")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }